"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapDispatchToActions = exports.actions = void 0;
var actions = {
  UPSERT: 'UPSERT',
  REMOVE: 'REMOVE',
  BULK_UPSERT: 'BULK_UPSERT'
};
exports.actions = actions;

var mapDispatchToActions = function mapDispatchToActions(dispatch) {
  return {
    upsertSegmentationData: function upsertSegmentationData(name, value) {
      return dispatch({
        name: name,
        value: value,
        type: actions.UPSERT
      });
    },
    removeSegmentationData: function removeSegmentationData(name) {
      return dispatch({
        name: name,
        type: actions.REMOVE
      });
    },
    bulkUpsertSegmentationData: function bulkUpsertSegmentationData(data) {
      return dispatch({
        data: data,
        type: actions.BULK_UPSERT
      });
    }
  };
};

exports.mapDispatchToActions = mapDispatchToActions;
var _default = actions;
exports.default = _default;